export const isAuthenticated = token => !!token;

export const saveToken = token => localStorage.setItem('token', token);

export const getToken = () => localStorage.getItem('token');

export const removeToken = () => localStorage.removeItem('token');

// Logout completo: limpia storage y fuerza redirección
// Usar cuando no hay acceso al contexto React (ej. interceptores, servicios)
export const fullLogout = () => {
  localStorage.clear();
  window.location.href = '/#/auth/signin';
};
